import { Reveal } from "./Reveal";
import { ChapterLabel } from "./ChapterLabel";
import { about } from "../data/content";

export default function About() {
  return (
    <section id="about" className="section-shell" data-testid="about-section">
      <div className="container-x">
        <ChapterLabel index="01" title="About" />
        <div className="grid md:grid-cols-[280px_1fr] gap-10 md:gap-14 items-start">
          <Reveal>
            <figure data-testid="about-portrait">
              <div className="border border-cardline bg-panel p-3">
                <img
                  src="/ritu-mali.jpg"
                  alt="Portrait of Ritu Mali"
                  className="w-full aspect-[4/5] object-cover object-top"
                />
              </div>
              <figcaption className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-faint">
                Ritu Mali — San Diego, CA
              </figcaption>
            </figure>
          </Reveal>
          <div className="max-w-2xl space-y-6">
            {about.map((line, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <p className={i === 0 ? "font-display text-xl sm:text-2xl text-ink leading-snug" : "text-base sm:text-lg text-body leading-relaxed"}>
                  {line}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
